import css from 'styled-jsx/css';

const styles = css.global`html.scroll-disabled-ldmodal {
  overflow: hidden !important;
}

#sn-loading-modal {
  display: flex;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 9999;
  align-items: center;
  justify-content: center;
  background-color: rgba(34, 34, 34, 0.6);
}

#sn-loading-modal .loader-wrapper {
  width: 314px;
  left: 0px;
  top: 0px;
  background: #ffffff;
  border: 1px solid rgba(34, 34, 34, 0.4);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

#sn-loading-modal.full {
  margin-top: 58px;
  background: transparent;
}

.full-header-space {
  height: 58px;
  position: fixed;
  top: 0;
  left: 0;
  padding: 0;
  margin: 0;
  background: transparent;
  z-index: 9999;
  box-sizing: border-box;
  width: 100%;
}

#sn-loading-modal.full .loader-wrapper {
  border-radius: 0;
  width: 100%;
  height: 100%;
  padding: 140px 16px 24px;
  margin: 0;
  box-sizing: border-box;
  border: none;
  background: rgba(255, 255, 255, 0.96);
  justify-content: flex-start;
}

#sn-loading-modal.full .loader-indicator {
  width: 98px;
  height: auto;
  box-sizing: border-box;
  object-fit: contain;
  padding: 0;
  margin: 0;
}

#sn-loading-modal .loading-title {
  font-family: SantanderMicroText;
  font-weight: 700;
  font-style: Bold;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: center;
  margin-top: 16px;
  color: #222;
}

#sn-loading-modal .loading-message {
  font-family: SantanderMicroText;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  text-align: center;
  margin-top: 16px;
  color: #727272;
}

#sn-loading-modal .loading-title + .loading-message {
  margin-top: 8px;
}

#sn-loading-modal.with-title .loader-wrapper,
#sn-loading-modal.with-message .loader-wrapper {
  padding: 16px 0;
}

#sn-loading-modal.full {
  padding: 0;
  border: none;
  outline: none;
}
#sn-loading-modal.full .loader-wrapper {
  padding: 0;
}

@media (min-width: 992px) {
  #sn-loading-modal .loader-wrapper {
    width: 484px;
  }

  #sn-loading-modal.full {
    margin-top: 80px;
  }

  .full-header-space {
    height: 80px;
  }

  #sn-loading-modal.full .loader-wrapper {
    padding-top: 168px;
  }
}
`;

export default styles;